<template>
  <div class="discus">
    <nav-bar
      fixed
      z-index="99"
      title="卡牌沟通"
      left-text="返回"
      left-arrow
      placeholder
      @click-left="$router.push('/game/my')"
    />
    <div class="discus-info">
      <div class="discus-info-title">{{ gameInfo.gameName }}</div>
      <nf-card borderInnerSize="0" bgColor="#fff">
        <div class="discus-info-card">
          <img class="discus-info-card-avatar" :src="userInfo.avatar" alt="" />
          <div class="discus-info-card-des">
            <div class="discus-info-card-des-name">{{ userInfo.nickname }}</div>
            <div class="discus-info-card-des-text">
              {{ coachInfo.storeInfo }}
            </div>
          </div>
        </div>
      </nf-card>
    </div>
    <div class="discus-step">
      <div
        class="discus-step-header"
        :style="{
          transform: gameStatus == 1 ? 'translateY(-20%)' : 'translateY(-50%)',
        }"
      >
        <Swipe :show-indicators="false" :loop="false">
          <SwipeItem v-for="(pItem, pIndex) in formatPlayerList" :key="pIndex">
            <div
              class="discus-step-header-tab"
            >
              <div
                v-for="item in pItem"
                class="discus-step-header-tab-item"
                :class="{ active: form.roleTab == item.id }"
                @click="changeTab(item.id)"
                :key="item.id"
              >
                {{ item.nickName }}
              </div>
            </div>
          </SwipeItem>
        </Swipe>

        <nf-card
          v-if="gameStatus == 1"
          :round="discusType != 2 && discusType != 3 ? '.5rem' : '0'"
          bgColor="#fff"
        >
          <div class="discus-step-header-info">
            <div class="discus-step-header-info-left">
              正在玩：
              <span style="font-weight: bold">{{ gameInfo.cateName }}</span> 的
              <span style="font-weight: bold">{{
                gameInfo.secondCateName ? gameInfo.secondCateName : "游戏"
              }}</span>
            </div>
            <div class="discus-step-header-info-right"></div>
          </div>
        </nf-card>
      </div>

      <div class="discus-step-content">
        <!-- 教练选择了玩家视图 -->
        <Discus1 v-if="discusType == 1" />
        <!-- 教练选择综合 -->
        <Discus2
          v-if="discusType == 2"
          :value.sync="form"
          :gameInfo="gameInfo"
          :gameStatus="gameStatus"
          @dealCard="dealCardHandle"
          @flip="openCard"
        />
        <!-- 教练选择了单个用户 -->
        <Discus3
          v-if="discusType == 3"
          :value.sync="form"
          :gameInfo="gameInfo"
          :gameStatus="gameStatus"
          @flip="openCard"
        />
      </div>
    </div>

    <div style="padding: 0.5rem 0" v-if="gameStatus == 1">
      <NfButton round=".5rem" color="rgb(255,122,110)" @click.native="exitGame"
        >结束游戏</NfButton
      >
    </div>
  </div>
</template>

<script>
import NfCard from "@/components/game-ui/NfCard.vue";
import NfButton from "@/components/game-ui/NfButton.vue";
import {
  RadioGroup,
  Radio,
  Image as VanImage,
  NavBar,
  Swipe,
  SwipeItem,
} from "vant";
import activeIcon from "@/assets/game/checked.png";
import inactiveIcon from "@/assets/game/no_checked.png";
import Discus1 from "./components/discus-1.vue";
import Discus2 from "./components/discus-2.vue";
import Discus3 from "./components/discus-3.vue";
import { getGameConfigByTag, getGameConfig } from "../config";
import ws from "@/utils/ws";
import $store from "@/store";
import {
  getPlayerList,
  getGameRecord,
  cardCategoryList,
  generateNextRoundConfig,
  getRoundConfig,
  modifyGameStatus,
  openCard,
  roundList,
} from "@/api/game";
import { coachInfo } from "@api/user";
export default {
  components: {
    NfCard,
    RadioGroup,
    Radio,
    VanImage,
    Discus1,
    Discus2,
    Discus3,
    NavBar,
    NfButton,
    Swipe,
    SwipeItem,
  },
  data() {
    return {
      coachInfo: {},
      radio: "1",
      activeIcon,
      inactiveIcon,
      // 1：价值观卡的图画
      discusType: 2,
      roleTab: 1,
      userInfo: {},
      gameStatus: 1,
      gameInfo: {
        gameId: null,
        gameRoundId: 1,
        cateId: 4,
        secondCateId: 5,
        gameRecordList: [],
        cateName: "",
        secondCateName: "",
      },

      formatPlayerList: [],
    };
  },
  computed: {
    form: {
      get: () => {
        return $store.state.game.discus.form;
      },
      set: (val) => {
        $store.commit("GAME_DISCUS_FORM", val);
      },
    },
  },
  async mounted() {
    this.userInfo = this.$store.state.app.userInfo;
    console.log("userInfo", this.userInfo);
    Object.assign(this.gameInfo, this.$route.query);
    // 获取游戏信息并开启socket
    const gameInfoRes = await this.getGameInfo();
    if (gameInfoRes.gameStatus == 1) {
      // 开启socket监听
      this.ws = new ws({
        url: `/game/${this.gameInfo.gameId}/${this.userInfo.uid}`,
        //心跳时间（单位:ms）
        heartBeat: 5000,
        //发送心跳信息（支持json传入）(这个一般内容不重要，除非后端变态)
        heartMsg: {
          roomId: this.gameInfo.gameId,
          userId: this.userInfo.uid,
          heartbeat: "ping",
        },
        //开起重连
        reconnect: true,
        //重连间隔时间（单位:ms）
        reconnectTime: 5000,
        //重连次数
        reconnectTimes: 10,
      });
      this.ws //接收信息
        .onmessage((data) => {
          console.log(data);
          if (data == "pong") {
            return;
          }
          this.wsMessage(JSON.parse(data));
        });
    }
    // 获取玩家列表
    this.getPlayerList();
    // 获取初始化卡牌列表
    this.getInitCardList();

    this.changeRoleTab(0);
    this.getCoachInfo();
  },
  methods: {
    wsMessage(data) {
      const dataJson = data;
      if (dataJson == "pong") {
        console.log("心跳");
        return;
      }
      // 教练重新发牌，进入下一轮游戏
      if (dataJson.type == 4) {
        this.$router.push({
          url: "/game/start",
          query: {
            gameId: dataJson.gameId,
            gameRoundId: dataJson.gameRoundId,
            cateId: dataJson.cateId,
            secondCateId: dataJson.secondCateId,
          },
        });
      }
      // 结束游戏，退出
      if (dataJson.gameStatus == 2) {
        this.$dialog.message("游戏结束");
        this.$router.push({
          path: "/game/my",
        });
      }
      // 用户选择完卡牌，进行刷新卡牌列表
      if (dataJson.type == 3) {
        this.changeRoleTab(this.form.roleTab);
        // 刷新玩家列表
        this.getPlayerList();
      }
      // 如果获取到的玩家人数比现有人数高，则刷新玩家列表
      if (dataJson.playerNum > this.playerList.length) {
        this.getPlayerList();
      }
    },
    // 获取玩家列表
    getPlayerList() {
      getPlayerList({ gameId: this.gameInfo.gameId }).then((res) => {
        if (res.success) {
          this.form.playerList = res.data;
        }
      });
    },
    // 获取游戏记录
    getGameRecord(playerId) {
      this.$dialog.loading.open("用户数据加载中...");
      return new Promise((resolve, reject) => {
        getGameRecord(this.gameInfo.gameId, playerId)
          .then((res) => {
            if (res.success) {
              this.form.gameRecordList = res.data;
              resolve(res.data);
            } else {
              reject(res);
            }
          })
          .catch((err) => {
            reject(err);
          })
          .finally(() => {
            this.$dialog.loading.close();
          });
      });
    },
    changeTab(val) {
      this.form.roleTab = val;
      if (val == -1) {
        this.discusType = 1;
      } else if (val != 0) {
        this.discusType = 3;
      } else {
        this.discusType = 2;
      }
    },
    // 根据不同类型进入不同游戏页面
    changeGame() {
      const config = getGameConfigByTag(this.gameInfo.tag);
      Object.assign(this.gameInfo, config);
      console.log("changeGame", this.gameInfo);
    },
    // 获取初始化卡牌列表
    getInitCardList() {
      cardCategoryList().then((res) => {
        if (res.success) {
          this.form.initCardList = res.data;
        }
      });
    },
    // 教练点击发牌
    async dealCardHandle() {
      this.clearAllBrand();
      const discusStatus = await this.discusConfirm();
      if (discusStatus == 0) {
        return;
      }
      // 确认同步上一轮
      this.form.openSync = 0;
      const config = getGameConfig(this.form.cateId, this.form.secondCateId);
      if (config.visibleType == "wheel") {
        this.form.openSync = await this.syncCardConfirm();
      }

      const cardIndex = this.form.initCardList.findIndex((item) => {
        return item.id == this.form.cateId;
      });
      if (cardIndex == -1) {
        this.$dialog.message("请选择卡牌类别");
        return;
      } else if (this.form.initCardList[cardIndex].children.length > 0) {
        const secondCardIndex = this.form.initCardList[
          cardIndex
        ].children.findIndex((item) => {
          return item.id == this.form.secondCateId;
        });
        if (secondCardIndex == -1) {
          this.$dialog.message("请选择卡牌二级类别");
          return;
        }
      }
      // 处理发牌
      const data = {
        cateId: this.form.cateId,
        secondCateId:
          this.form.secondCateId != 0 ? this.form.secondCateId : null,
        gameId: this.gameInfo.gameId,
        extractNum: this.form.extractNum,
        openSync: this.form.openSync,
      };
      generateNextRoundConfig(data)
        .then((res) => {
          if (res.success) {
            this.$dialog.message("发牌成功，等待玩家选择卡牌");
            // 重新获取游戏记录
            this.getGameRecord(0).then((res) => {
              res = res.map((item) => {
                return Object.assign(item, { brandStatus: false });
              });
              this.form.cardList = res;
              // 更新当前轮次
              this.gameInfo.gameRoundId = res[0].roundId;
              // 清空选中
              this.form.cateId = 0;
              this.form.cateName = "";
              this.form.secondCateId = 0;
              this.form.secondCateName = "";
            });
            // this.changeTab(this.form.roleTab);
            this.getGameInfo();
            // 回到顶部
            document.documentElement.scrollTop = 0;
          } else {
            this.$dialog.message(res.msg);
          }
        })
        .catch((err) => {
          this.$dialog.message(err.msg);
        });
    },
    // 清空所有已翻面
    clearAllBrand() {
      console.log("this.form", this.form);
      this.form.cardList.map((item) => {
        item.isOpen = false;
      });
      this.form.playerList.map((item) => {
        item.isOpen = false;
      });
    },
    syncCardConfirm() {
      return new Promise((resolve, reject) => {
        let isSameGame = false;
        // 判断之前是否有同类型的游戏
        roundList({ gameId: this.gameInfo.gameId })
          .then((res) => {
            if (res.success) {
              const roundList = res.data;
              const config = getGameConfig(
                this.form.cateId,
                this.form.secondCateId
              );
              roundList.map((item) => {
                if (item.cardCategory.tag == config.tag) {
                  isSameGame = true;
                }
              });
              if (isSameGame) {
                this.$dialog.confirm({
                  title: "提示",
                  mes: "是否同步上一轮游戏",
                  opts: [
                    {
                      txt: "取消",
                      color: false,
                      callback: () => {
                        resolve(0);
                      },
                    },
                    {
                      txt: "确定",
                      color: true,
                      callback: () => {
                        resolve(1);
                      },
                    },
                  ],
                });
              } else {
                resolve(0);
              }
            } else {
              resolve(0);
            }
          })
          .catch((err) => {
            resolve(0);
          });
      });
    },
    discusConfirm() {
      return new Promise((resolve, reject) => {
        this.$dialog.confirm({
          title: "提示",
          mes: "请确保所有游戏参与者已完成本轮选牌及沟通",
          opts: [
            {
              txt: "取消",
              color: false,
              callback: () => {
                resolve(0);
              },
            },
            {
              txt: "确定",
              color: true,
              callback: () => {
                resolve(1);
              },
            },
          ],
        });
      });
    },
    // 获取当前游戏信息
    getGameInfo() {
      return new Promise((resolve, reject) => {
        getRoundConfig({ gameId: this.gameInfo.gameId }).then((res) => {
          if (res.success) {
            this.gameInfo.cateName = res.data.cardGameRound.cateName;
            this.gameInfo.secondCateName =
              res.data.cardGameRound.secondCateName;
            this.gameInfo.gameName = res.data.gameName;
            this.gameInfo.gameStatus = res.data.gameStatus;
            // Object.assign(this.gameInfo, res.data.cardGameRound);
            // 模拟assign
            for (let key in res.data.cardGameRound) {
              this.gameInfo[key] = res.data.cardGameRound[key];
            }

            console.log("gameInfo", this.gameInfo);
            this.gameInfo.gameRoundId = res.data.cardGameRound.id;
            this.gameStatus = res.data.gameStatus || 1;
            this.changeGame();
            resolve(res.data);
          }
        });
      });
    },
    // 结束游戏
    exitGame() {
      this.$dialog.confirm({
        mes: "是否结束当前游戏？",
        opts: () => {
          modifyGameStatus({ gameId: this.gameInfo.gameId, status: 2 })
            .then((res) => {
              this.$dialog.message("游戏已结束");
              this.$router.push({
                path: "/game/my",
              });
            })
            .catch((err) => {
              this.$dialog.message(err.msg);
            });
        },
      });
    },
    changeRoleTab(val) {
      this.form.cardList.splice(0, this.form.cardList.length);
      this.getGameRecord(val).then((res) => {
        if (val == 0) {
          res = res.map((item) => {
            return Object.assign(item, { brandStatus: false });
          });

          this.form.cardList = res;
        } else {
          // 清空
          this.form.frontSelectCardList.splice(
            0,
            this.form.frontSelectCardList.length
          );
          this.form.cardList.splice(0, this.form.cardList.length);
          for (let item of res) {
            // 当前轮次选择的卡牌
            if (
              item.roundId == this.gameInfo.gameRoundId &&
              this.gameInfo.gameStatus == 1
            ) {
              if (item.records.length > 0) {
                this.form.cardList = item.records;
              }
            } else {
              // 之前的选择
              this.form.frontSelectCardList.push({
                records: item.records,
                roundNum: item.roundNum,
                cateName: item.cateName,
              });
              this.form.frontSelectCardList.sort((a, b) => {
                return b.roundNum - a.roundNum;
              });
            }
          }
        }
      });
    },
    // 教练翻牌
    openCard(item) {
      const data = {
        gameId: this.gameInfo.gameId,
        playerId: null,
        roundId: this.gameInfo.gameRoundId,
        userId: null,
      };
      // 获取当前玩家信息
      if (this.form.roleTab == 0) {
        data.playerId = item.playerId;
        data.userId = item.userId;
      } else {
        const player = this.form.playerList.find(
          (item) => item.id == this.form.roleTab
        );
        data.playerId = player.id;
        data.userId = player.userId;
      }
      openCard(data).then(() => {});
    },
    getCoachInfo() {
      coachInfo().then((res) => {
        if (res.success) {
          this.coachInfo = res.data;
        }
      });
    },
  },
  watch: {
    "form.roleTab": {
      handler: function (val) {
        if (val == -1) return;
        this.changeRoleTab(val);
      },
    },
    "form.playerList": {
      handler: function (val) {
        const list = [...val];
        list.unshift({
          id: -1,
          nickName: "自己",
        });
        list.unshift({
          id: 0,
          nickName: "综合",
        });
        const formatPlayerList = [];
        const len = list.length;
        const groupNum = Math.ceil(len / 3);
        for (let i = 0; i < groupNum; i++) {
          const arr = [];
          for (let j = 0; j < 3; j++) {
            if (list[i * 3 + j]) {
              arr.push(list[i * 3 + j]);
            }
          }
          formatPlayerList.push(arr);
        }
        this.formatPlayerList = formatPlayerList;
        console.log("formatPlayerList", formatPlayerList);
      },
      deep: true,
      immediate: true,
    },
    gameInfo: {
      deep: true,
      immediate: true,
    },
  },
  // 断开链接
  beforeDestroy() {
    this.ws.close();
    this.ws.ws.close();
    this.ws = null;
    console.log("销毁ws");
  },
};
</script>

<style lang="scss" scoped>
.discus {
  width: 100%;
  position: relative;
  padding-bottom: 0.2rem;
  // background: url(~@/assets/game/bg.png) 100% no-repeat;
  // background-size: 100% 100%;
  &-info {
    width: 100%;
    background-color: rgb(172, 185, 233);
    padding: 0.8rem 0.5rem;
    padding-top: 0rem;
    &-title {
      font-size: 0.3rem;
      color: #fff;
      text-align: center;
    }
    &-card {
      display: flex;
      align-items: center;
      &-avatar {
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 0.1rem;
        margin-right: 0.2rem;
      }
      &-des {
        font-size: 0.25rem;
        &-name {
        }
        &-text {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
  &-step {
    width: 100%;
    &-header {
      width: 100%;
      transform: translateY(-20%);
      &-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 0.25rem;
        color: #666;
        &-left {
        }
        &-right {
          &-radio {
            display: flex;
            align-items: center;
            .van-radio {
              margin-right: 0.2rem;
            }
          }
        }
      }
      &-tab {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 0.25rem;

        .active {
          background-color: rgb(255, 210, 93);
        }

        &-item {
          background-color: #fff;

          border-top-left-radius: 0.3rem;
          border-top-right-radius: 0.3rem;
          border: 0.03rem solid #666;
          width: 100%;
          text-align: center;
          padding: 0.2rem 0;
          border-bottom: 0.02rem solid #666;
        }
      }
    }
    &-content {
      padding: 0 0.1rem;
      margin-top: -0.2rem;
    }
  }
}

::v-deep .van-nav-bar {
  background-color: rgb(172, 185, 233) !important;
}

::v-deep .van-grid-item__content {
  background-color: inherit !important;
}
</style>

<style>
.van-grid-item__content {
  background-color: inherit !important;
}
</style>
